export default __webpack_public_path__ + "static/media/a037-k.350d3a2e.jpg";